// @ts-check
import { faker } from '@faker-js/faker';

/** @typedef {import('@/store/modules/bulkSend/models/ImportedRowData').TImportedRowData} TImportedRowData */

function parseErrors(errors) {
  return Object.entries(errors)
    .map(([field, error]) => `${field} - ${error}`)
    .join(' ');
}

/**
 * @param {number} count
 * @param {string[]} columns
 * @param {Partial<TImportedRowData>[]} [data]
 *
 * @return {TImportedRowData[]}
 */
function createImportedData(count, columns, data = []) {
  if (count >= 1) {
    return Array.from(Array(count), (_, index) => {
      const errorCol = columns.findIndex(col => col === 'Reason');
      const errors = errorCol > -1 && data[index][errorCol];

      return columns.map((column, cIndex) => {
        if (data[index] && data[index][cIndex]) {
          if (column === 'Reason') {
            return parseErrors(data[index][cIndex]);
          }

          return data[index][cIndex];
        }
        if (errors && errors[column]) {
          return '';
        }
        if (column === 'Row') {
          return index + 1;
        }
        if (column.includes('Name')) {
          return faker.person.fullName();
        }
        if (column.includes('Envelope')) {
          return faker.lorem.sentence();
        }
        if (column.includes('Email')) {
          return faker.internet.email();
        }
        if (column) {
          return faker.animal[faker.animal.type()]();
        }

        return '';
      });
    });
  }

  return [];
}

export default createImportedData;
